import React from 'react';
import { Section, Container } from '../common';
import mockupImage from '../../assets/images/mockup-cardapio-mix.png';

const Hero = () => {
  return (
    <Section id="inicio" className="bg-white overflow-hidden">
      <Container>
        <div className="row align-items-center">
          <div className="col-lg-6 mb-5 mb-lg-0 hero-content" data-aos="fade-right">
            <h1 className="fw-bold mb-4">
              Transforme seu restaurante em uma máquina de pedidos online
            </h1>
            <p className="lead text-secondary mb-4">
              Crie seu cardápio digital, receba pedidos automaticamente e aumente suas vendas sem depender de marketplaces.
            </p>
            <p className="text-secondary mb-5 d-none d-md-block">
              Com nossa plataforma você cria seu próprio cardápio digital, recebe pedidos por WhatsApp ou site e automatiza todo o atendimento do seu delivery ou restaurante.
            </p>
            <div className="d-flex flex-wrap gap-3 hero-buttons animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
              <a href="/cadastro" className="btn btn-primary-custom btn-lg px-5 py-3 shadow-sm hover-lift">Criar meu cardápio</a>
              <a href="#funcionalidades" className="btn btn-outline-custom btn-lg px-5 py-3 hover-lift">Ver funcionalidades</a>
            </div>
          </div>
          <div className="col-lg-6 mt-4 mt-lg-0" data-aos="fade-left" data-aos-delay="200">
            <div className="position-relative">
              <div 
                className="bg-primary-custom rounded-circle position-absolute d-none d-sm-block" 
                style={{ width: '80%', height: '80%', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 0, opacity: 0.2 }}
              ></div>
              <img 
                src={mockupImage}
                alt="Mockup do App Léo Delivery" 
                className="img-fluid position-relative mx-auto d-block" 
                style={{ zIndex: 1, maxWidth: '100%', height: 'auto' }}
              />
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default Hero;
